define([
    "base/utils/iamValidator",
    "language/resource",
    "base/utils/utility",
    "authui/iamEnv"
], function (IAMValidator, i18n, utils, iamEnv) {
    "user strict";
    var iamUtils = {};

    iamUtils.layout = {
        btnMinWidth: "70px",
        searchBoxWidth: "200px",
        inputLabelWidth: "200px",
        inputFiledWidth: "300px",
        inputFiledWidthHalf: "125px",
        inputFieldHeight: "36px",
        scrollHeight: "200px",
        loginInputFiledWidth: "100%",
        loginInputFieldHeight: "48px",
    };

    var iamValidator = new IAMValidator(i18n);
    iamUtils.validator = iamValidator.getCompoundValidator();
    iamUtils.directValidator = iamValidator.getCompoundDirectValidator();
    iamUtils.directValidator.phone = iamUtils.directValidator.phoneAdd;
    iamUtils.unifyValid = iamValidator.unifyValid;

    iamUtils.clearPwdDisplayLevel = utils.clearPwdDisplayLevel;
    iamUtils.getPwdStrengthLevel = utils.getPwdStrengthLevel;
    iamUtils.trimSpace = utils.trimSpace;
    iamUtils.getTrimValue = utils.getTrimValue;
    iamUtils.i18nFormat = utils.i18nFormat;
    iamUtils.getUrlParams = utils.getUrlParams;

    iamUtils.MESSAGE = utils.getMessageInstance("550px", i18n);
    iamUtils.mobileMessage = utils.getMobileMessageInstance("300px", i18n);
    iamUtils.SecurityMasker = utils.getSecurityMasker();
    iamUtils.SortArray = utils.SortArray;
    iamUtils.getCodeValue = utils.getCodeValue;
    iamUtils.getCountryValue = utils.getCountryValue;
    iamUtils.getDomainURL = utils.getEmailURL;
    iamUtils.getCountryCode = utils.getCountryCode;
    iamUtils.needRecordUsername = true;
    iamUtils.getPubPhoneLen = utils.getPubPhoneLen;
    iamUtils.getMailbox =utils.getMailbox;
    iamUtils.setPwdLevel = utils.setPwdLevel;
    iamUtils.getPhoneRegex = utils.getPhoneRegex;
    iamUtils.setPwdLevelByLevel = utils.setPwdLevelByLevel;
    iamUtils.isSupportSms = true;
    iamUtils.getCurrentTimeZone = utils.getCurrentTimeZone;
    iamUtils.getAuthenticationUrl = utils.getAuthenticationUrl;

    function getConfig() {
        var config = {
            homepageUrl: window.replaceDomain("http://www.huaweicloud.com/?locale={0}"),
            HongKongHomepageUrl: window.replaceDomain("https://intl.huaweicloud.com"),
            bssAccountInfoUrl: window.replaceDomain("https://account.huaweicloud.com/usercenter?locale={0}#/userindex/cusmanagement"),
            helpCenterUrl: window.replaceDomain(iamEnv.ipIsInternational() ? "https://support-intl.huaweicloud.com" : "http://support.huaweicloud.com"),
            consoleHomeUrl: window.replaceDomain("https://console.huaweicloud.com/console/"),
            userCenterUrl: window.replaceDomain("https://account.huaweicloud.com/usercenter"),
            hkUserCenterUrl: window.replaceDomain("https://account-intl.huaweicloud.com/usercenter/"),
            authenticationUrl: window.replaceDomain("http://activity.huaweicloud.com/newuser_trial/index.html"),
            styleOfSite:"",
            vmallCASUrl: window.replaceDomain("https://hwid1.vmall.com"),
            hasQrlogin: "true", 
            hasHwid: "true",
            hasHwCloudLink: "true", //华为ID登录页是否有华为云帐号登录链接
            cbcRegUrl: window.replaceDomain("https://reg.huaweicloud.com/registerui/cn/register.html?locale={0}"),
            cbcRegUrlIntl: window.replaceDomain("https://reg.huaweicloud.com/registerui/intl/register.html?locale={0}"),
            upgradeDescLink: window.replaceDomain('https://support.huaweicloud.com/account_faq/faq_id_0050.html'),
            baseDomain: window.replaceDomain("huaweicloud.com"), // xxx.com 或 xxx.cn
        };
        for (var key in config) {
            if (Object.prototype.hasOwnProperty.call(config, key) && config[key]) {
                config[key] = utils.i18nFormat(config[key], window.language);
            }
        }
        return config;
    }

    iamUtils.CONFIG = getConfig();
    iamUtils.EmailRegex = utils.EmailRegex;
    iamUtils.redirect2Login = function () {
        var service = iamUtils.getUrlParams()["service"];
        var language = window.language;
        if (service && language) {
            window.location.href = "/authui/?locale=" + language + "&service=" + encodeURIComponent(iamUtils.getUrlParams()["service"]);
        } else if (service && !language) {
            window.location.href = "/authui/?service=" + encodeURIComponent(iamUtils.getUrlParams()["service"]);
        } else {
            window.location.href = "/authui/?locale=" + language;
        }
    }
    iamUtils.hwPDACloudService = "https://hwid1.vmall.com/oauth2/portal/regbyphone.jsp?service=http%3A%2F%2Fwww1.hicloud.com%3A80%2Fuser%2Fdrump.action%3Furi%3D%2Fuser%2Flogin.action%26lang%3Dzh-cn&loginChannel=1000002&reqClientType=1&deviceID=&lang=zh-cn&InviterUserID=&Inviter=&isFromPC=1&loginUrl=https://hwid1.vmall.com/oauth2/portal/cloud_login.jsp&adUrl=https%3A%2F%2Fwww1.hicloud.com%2Fothers%2Fshow_advert.action%3Flang%3Dzh-cn&viewType=0&isDialog=0&themeName=cloudTheme";
    iamUtils.enterEvent=function(event,callBack){
        if(event.keyCode===13){
            callBack();
        }
    }
    
    // add style of Russia
    iamUtils.isShowByStyleOfSite = function()
    {
    	return (iamUtils.CONFIG.styleOfSite == "Russia") ? true :false;
    }
    // 拆分于iamEnv.js
    iamUtils.ipIsInternational = iamEnv.ipIsInternational;

    //自定义UI4.0风格tip，ele为需要被绑定tip的元素
    //推荐在ng-init中调用此函数，以免出现元素未初始化的情况
    iamUtils.showTooltip = function (ele, content, maxWidth) {

        if(!(ele instanceof jQuery)) {
            return ;
        }

        var tipHtml = '<div class="iam-ti-tooltip iam-ti-tooltip-top-left" \
                            style="display: block;"> \
                            <div class="iam-ti-tooltip-content"  \
                            style="overflow-y: auto; padding: 1px; white-space: normal;"> \
                            TIP_CONTENT</div>\
                    <div class="iam-ti-tooltip-top-left-sqr"></div></div>'
            .replace('TIP_CONTENT', content);

        var tip;
        var isShown = false;
        var maxW = maxWidth ? maxWidth : '320px';

        var addTip = function () {
            var pos = ele.first().offset();
            tip = $(tipHtml);
            tip.css('left', pos.left);
            tip.css('max-width', maxW);
            $(document.body).append(tip);
            tip.css('top', pos.top - tip.outerHeight() - 14);
            tip.mouseleave(
                function () {
                    tip && tip.remove();
                }
            )
            isShown = true;
        }

        ele.mouseenter(
            function () {
                //光标进入元素区域，显示tip
                setTimeout(
                    function () {
                        if (ele.is(":hover") && !isShown) {
                            addTip();
                        }
                    }, 500
                )
            }
        ).mouseleave(
            function () {
                //若光标移动到tip上，不自动消失
                setTimeout(
                    function () {
                        if (tip && !(tip.is(":hover"))) {
                            isShown = false;
                            tip && tip.remove();
                        }
                    }
                    , 300
                )
            }
        ).on('keypress', function (e) {
            //回车后移除tip
            if (e.which == 13) {
                tip && tip.remove();
            }
        })
        .click(
            //兼容移动端触摸场景
            function () {
                if (ele.is(":hover") && !isShown) {
                    addTip();
                }
            }
        ).blur(
            function () {
                tip && !tip.is(":hover") && tip.remove();
            }
        );
    }

    iamUtils.initialCloudBI = function(url, params){
        var biInterval = setInterval(function(){
            if(window.init && onPageView){
                initialCloudBI();
                addPageView4CloudBI(url, params);
                clearInterval(biInterval);
            }
        }, 1000);
    }
    
    iamUtils.pages = {
        login: "iam_loginwebsite_login",
        upgrade: "iam_loginwebsite_upgrade",
    }

    iamUtils.getShowConfig = function (cookieOp) {
        var configParam = utils.getUrlParams().showConfig;
        if (configParam) {
            cookieOp.addCookie('login_show_config', configParam);
        } else {
            configParam = cookieOp.getCookie('login_show_config') ? cookieOp.getCookie('login_show_config') : '';
        }
        return {
            config: !!configParam,
            lang: configParam.charAt(0) !== '0',
            otherWay: configParam.charAt(1) !== '0',
            iamLogin: configParam.charAt(2) !== '0',
            oldLogin: configParam.charAt(3) !== '0',
        }
    }

    iamUtils.validateUrl = function (service) {
        var reg = /^(https?:)?\/\/[^\s]*/;
        return reg.test(service);
    }

    return iamUtils;
});



// WEBPACK FOOTER //
// ./public/hws/js/iamUtils.js